(function() {
  // Single global drag state — one window.mouseup listener for ALL sliders, no leak
  var globalDrag = { active: false, startX: 0, callback: null, threshold: 40 };

  window.addEventListener('mouseup', function(e) {
    if (!globalDrag.active || !globalDrag.callback) return;
    globalDrag.active = false;
    var dx = e.clientX - globalDrag.startX;
    if (Math.abs(dx) > globalDrag.threshold) {
      globalDrag.callback(dx < 0 ? 1 : -1);
    }
    globalDrag.callback = null;
  });

  function initSlider(slider) {
    if (slider.hasAttribute('data-slider-ready')) return;
    slider.setAttribute('data-slider-ready', '1');

    var track = slider.querySelector('.aykaa-card-slider__track');
    var dots = slider.querySelectorAll('.aykaa-card-slider__dot');
    var slides = slider.querySelectorAll('.aykaa-card-slider__slide');
    var total = slides.length;
    if (total < 2) return;

    var current = 0;
    var startX = 0;
    var startY = 0;
    var isDragging = false;
    var threshold = 40;

    function goTo(index) {
      current = (index + total) % total;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach(function(d, i) {
        d.classList.toggle('active', i === current);
      });
    }

    function navigate(dir) { goTo(current + dir); }

    /* Touch */
    slider.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      isDragging = true;
    }, { passive: true });

    slider.addEventListener('touchmove', function(e) {
      if (!isDragging) return;
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;
      if (Math.abs(dy) > Math.abs(dx)) { isDragging = false; return; }
      if (Math.abs(dx) > 5) e.preventDefault();
    }, { passive: false });

    slider.addEventListener('touchend', function(e) {
      if (!isDragging) return;
      isDragging = false;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > threshold) { dx < 0 ? goTo(current + 1) : goTo(current - 1); }
    }, { passive: true });

    /* Mouse drag — uses single global window handler above, no per-slider window listener */
    slider.addEventListener('mousedown', function(e) {
      globalDrag.active = true;
      globalDrag.startX = e.clientX;
      globalDrag.callback = navigate;
    });

    slider.addEventListener('mouseleave', function() {
      if (globalDrag.callback === navigate) {
        globalDrag.active = false;
        globalDrag.callback = null;
      }
    });
  }

  function initAllSliders() {
    document.querySelectorAll('.aykaa-card-slider:not([data-slider-ready])').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSliders);
  } else {
    initAllSliders();
  }

  var observer = new MutationObserver(function(mutations) {
    var hasNewNodes = mutations.some(function(m) { return m.addedNodes.length > 0; });
    if (hasNewNodes) initAllSliders();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', initAllSliders);
})();
